import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import WhyChoose from "@/components/site/WhyChoose";
import MenuSection from "@/components/site/MenuSection";
import DrinksSection from "@/components/site/DrinksSection";
import Marquee from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import Catering from "@/components/site/Catering";
import Delivery from "@/components/site/Delivery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    if (typeof window !== "undefined") window.__lenis = lenis;

    // Anchor navigation via Lenis
    const handleAnchor = (e) => {
      const link = e.target.closest("a[href^='#']");
      if (!link) return;
      const id = link.getAttribute("href");
      if (id && id.length > 1) {
        e.preventDefault();
        const el = document.querySelector(id);
        if (el) lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#0D0D0D] text-white font-body min-h-screen">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhyChoose />
        <MenuSection />
        <DrinksSection />
        <Marquee />
        <Gallery />
        <Catering />
        <Delivery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
